"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Types_1 = require("../Types");
var PackState = /** @class */ (function () {
    function PackState() {
        this.value = "";
        this.displayName = "";
    }
    PackState.None = { value: "", displayName: "None" };
    PackState.Active = { value: "Active", displayName: "Active" };
    PackState.Supplied = { value: "Supplied", displayName: "Supplied" };
    PackState.Locked = { value: "Locked", displayName: "Mark as Locked" };
    PackState.Exported = { value: "Exported", displayName: "Exported" };
    PackState.Sample = { value: "Sample", displayName: "Sample" };
    PackState.FreeSample = { value: "FreeSample", displayName: "Free Sample" };
    PackState.Stolen = { value: "Stolen", displayName: "Stolen" };
    PackState.Destroyed = { value: "Destroyed", displayName: "Destroyed" };
    //I know verify isn't a pack state but verilite sucks
    PackState.Verify = { value: "Verify", displayName: "Verify" };
    PackState.parse = function (value) {
        switch (value) {
            case Types_1.PackAction.Verify.value:
                return PackState.Verify;
            case Types_1.PackAction.Supply.value:
                return PackState.Supplied;
            case Types_1.PackAction.MarkAsLocked.value:
                return PackState.Locked;
            case Types_1.PackAction.ExportFromEU.value:
                return PackState.Exported;
            case Types_1.PackAction.MarkAsSample.value:
                return PackState.Sample;
            case Types_1.PackAction.MarkAsFreeSample.value:
                return PackState.FreeSample;
            case Types_1.PackAction.MarkAsStolen.value:
                return PackState.Stolen;
            case Types_1.PackAction.MarkAsDestroyed.value:
                return PackState.Destroyed;
            case Types_1.PackAction.Reintroduce.value:
            case Types_1.PackAction.UndoMarkAsLocked.value:
            case Types_1.PackAction.UndoExportFromEU.value:
            case Types_1.PackAction.UndoMarkAsSample.value:
            case Types_1.PackAction.UndoMarkAsFreeSample.value:
            case Types_1.PackAction.UndoMarkAsStolen.value:
            case Types_1.PackAction.UndoMarkAsDestroyed.value:
            case Types_1.PackAction.Reactivate.value:
                return PackState.Active;
            case Types_1.PackAction.None.value:
            default:
                return PackState.None;
        }
    };
    return PackState;
}());
exports.PackState = PackState;
//# sourceMappingURL=PackState.js.map